import { Route } from 'react-router-dom';
import { Employee_Routes } from '../../constants';
import { ProfilePage } from '../../pages/authenticated/private';
import { HomeEmployeesPortal } from '../../pages/employees-portal/home/HomeEmployeesPortal';
import { NotFoundRoutes } from '../../security';
import { useStore } from '../stores/store';
import Footer from './Footer';
import Header from './Header';

const EmployeeAuthenticatedLayout = () => {
    const { commonStore } = useStore();

    return (
        <>
            <Header />
            <NotFoundRoutes redirect={Employee_Routes.HOME}>
                <Route
                    path={Employee_Routes.HOME}
                    element={<HomeEmployeesPortal />}
                />
                <Route path={Employee_Routes.PROFILE} element={<ProfilePage />} />
            </NotFoundRoutes>
            <Footer />
        </>
    );
};

export default EmployeeAuthenticatedLayout;
